// removed by extract-text-webpack-plugin
module.exports = {"encoding-pane":"encoding-pane__encoding-pane___Zpqme","shelf-group":"encoding-pane__shelf-group___1kWAl"};